import { render, staticRenderFns } from "./detail_supplyChain.vue?vue&type=template&id=ccac961a&scoped=true&"
import script from "./detail_supplyChain.vue?vue&type=script&lang=js&"
export * from "./detail_supplyChain.vue?vue&type=script&lang=js&"
import style0 from "./detail_supplyChain.vue?vue&type=style&index=0&id=ccac961a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccac961a",
  null
  
)

export default component.exports